import { ChartData } from "../../dataset-window/models/types";
import { PlotDataEx } from "../interfaces";

export const configLineChartData = (data: ChartData[], selectedColorPalette: Array<string>) => {
  return createPlotDataArr(data, selectedColorPalette);
};

const createPlotData = (d: ChartData, colorHex: string): PlotDataEx => {
  return {
    name: d.title,
    type: "scatter",
    mode: "lines",
    unit: d.unit,
    showlegend: true,
    hovertemplate: `<b>%{y:.3f}</b> at %{x} <br>${d.title}<extra></extra>`,
    x: d.keyArr, 
    y: d.valueArr,
    opacity: 0.7,
    marker: {
      color: colorHex,
    },
  } as PlotDataEx;
};

const createPlotDataArr = (data: Array<ChartData>, selectedColorPalette: Array<string>): Array<PlotDataEx> => {
  return data?.map((d: ChartData, index: number) => {
    return createPlotData(d, selectedColorPalette[index]);
  });
};